import React from 'react';
import { Link } from "react-router-dom"
const Uganda_baby2_subjects = () => {
  return (
    <div className="fixed p-4 right-0 left-0 content-center gap-4 w-full h-7 overflow-x-scroll whitespace-nowrap scroll-smooth bg-blue-300  flex scrollbar-hide items-center  top-30 z-9999">
      <Link to="/international/uganda/uganda_baby2/uganda_baby2math" className='text-white text-sm flex rounded  px-3 pb-2 pt-2'>Mathematics</Link>
        <Link to="/international/uganda/uganda_baby2/uganda_baby2eng" className='text-white text-sm flex rounded px-3 pb-2 pt-2'>English</Link>
        <Link to="/international/uganda/uganda_baby2/uganda_baby2scie" className='text-white text-sm flex  rounded px-3 pb-2 pt-2'>Science</Link>
        <Link to="/international/uganda/uganda_baby2/uganda_baby2soc"  className='text-white text-sm flex   rounded px-3 pb-2 pt-2'>Social Studies</Link>
        
    </div>

  );
}

export default Uganda_baby2_subjects;